export enum PRODUCTIONCOUNTRY {
	Colombia = 1,
	Mexico = 2,
	Brasil = 3,
}